import { render, staticRenderFns } from "./loading-logo.vue?vue&type=template&id=1516383c&scoped=true"
import script from "./loading-logo.vue?vue&type=script&lang=js"
export * from "./loading-logo.vue?vue&type=script&lang=js"
import style0 from "./loading-logo.vue?vue&type=style&index=0&id=1516383c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516383c",
  null
  
)

export default component.exports